import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import BabyRegistryInfo from '../BabyRegistryInfo/BabyRegistryInfo'
import { BirthdayRegistryInfo } from '../BirthdayRegistryInfo/BirthdayRegistryInfo'

const RegistryInfo = (props: any) => {
  const [currentUser] = useCurrentUser()

  if (
    currentUser?.currentRegistry?.type === 'birthday' ||
    currentUser?.currentRegistry?.type === 'holiday'
  ) {
    return <BirthdayRegistryInfo {...props} />
  }

  return <BabyRegistryInfo {...props} />
}
export default RegistryInfo
